<template>
  <v-layout>
    <v-flex>
      <template>
        <v-card class="pa-3">
          <div>
            <v-form>
              <nx-content-selector
                key="i"
                :allowNonPublished="true"
                :type="hasLandingPageContentTypes"
                :label="$t('message.block.form.content.search')"
                @input="selectUrl($event)"
              >
              </nx-content-selector>
            </v-form>
            <v-form class="mt-4">
              <v-text-field :value="url"
                            label="Inserta una url o seleccionala del buscador"
                            @input="updateUrl($event)"
              >
              </v-text-field>
            </v-form>
            <div style="text-align: left;" v-if="!emptyLog">Log:</div>
            <v-flex xs12>
              <pre style="max-height: 400px; overflow: scroll; text-align: left;  max-width: 90vw;"
                   v-if="!emptyLog">{{ log }}</pre>
            </v-flex>
            <v-container fluid class="pa-0 mt-2">
              <v-layout wrap align-center>
                <v-flex xs12>
                  <div class="text-xs-center">
                    <div>
                      <v-btn @click="routeResolve()"
                             :loading="this.loading"
                             :color="this.validatedUrl ? 'accent' : 'primary'" small>
                        View
                      </v-btn>
                    </div>
                  </div>
                  <div class="text-xs-center">
                    <div>
                      <v-btn v-if="!emptyLog" @click="copyFunction()" color="primary" small>
                        Copy
                      </v-btn>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-card>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import $http from '@/api';
import { mapGetters, mapState } from 'vuex';
import NxContentSelector from '@/modules/content/selector/Selector';

export default {
  name: 'nx-backstage-route-resolve',
  data() {
    return {
      url: '',
      log: [],
      loading: false,
    };
  },
  components: {
    NxContentSelector,
  },
  computed: {
    ...mapState(['site']),
    ...mapGetters(['hasLandingPageContentTypes']),
    emptyLog() {
      return Object.keys(this.log).length === 0;
    },
    emptyUrl() {
      return this.url === '';
    },
    validatedUrl() {
      return !this.emptyUrl;
    },
  },
  methods: {
    updateUrl(event) {
      this.url = event;
      this.log = [];
    },
    selectUrl(event) {
      this.url = event.publicUrl;
      this.log = [];
    },
    async routeResolve() {
      this.loading = true;
      try {
        this.log = await $http.post('/api/backstage/front/route', { url: this.url, siteId: this.site.id });
      } catch (e) {
        this.json = JSON.stringify(e.response.data, null, 2);

        this.log = [
          `Error! Status ${e.response.status} - ${e.response.statusText}`,
          this.json.split('\n'),
        ];
      } finally {
        this.loading = false;
      }
    },
    copyFunction() {
      const textArea = document.createElement('textarea');
      textArea.textContent = JSON.stringify(this.log, null, 2);
      document.body.append(textArea);
      textArea.select();
      document.execCommand('copy');
    },
  },
};

</script>
<style scoped>
form {
  padding-right: 8px;
  padding-left: 8px;
}
textarea {
  position: absolute;
  left: -100%;
}
</style>
